export enum Channel {
  GA = "GA",
  TEALIUM = "TEALIUM",
  ALL = "ALL",
}
